import produce from 'immer'

import {
  DESIGN_MATCHES_V2_LOAD,
  DESIGN_MATCHES_V2_LOAD_FAILURE,
  DESIGN_MATCHES_V2_LOAD_SUCCESS
} from './actions'
import { VerificationCheckData } from './types'

interface DesignMatchesV2State {
  loading: boolean
  error: null | string
  data: VerificationCheckData | null
}

const initialState: DesignMatchesV2State = {
  loading: false,
  error: null,
  data: null
}

export const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case DESIGN_MATCHES_V2_LOAD: {
        draft.loading = true
        draft.error = null
        return
      }
      case DESIGN_MATCHES_V2_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.data = action.data
        return
      }
      case DESIGN_MATCHES_V2_LOAD_FAILURE: {
        draft.loading = false
        draft.error = action.error
        return
      }
      default:
        return
    }
  })
